import { render, staticRenderFns } from "./OfferObjectsMap.vue?vue&type=template&id=2345f6c9"
import script from "./OfferObjectsMap.vue?vue&type=script&lang=ts"
export * from "./OfferObjectsMap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports